import { Component, ChangeDetectorRef } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { ReportAddUnitPage } from "../report-add-unit/report-add-unit";
import { ReportEditUnitPage } from "../report-edit-unit/report-edit-unit";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportService } from "../../services/report.service";
import { ApiService } from "../../services/api.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-report-select-unit',
  templateUrl: 'report-select-unit.html',
})
export class ReportSelectUnitPage {

  public data: any;
  public units: any;
  public allowAddUnit = false;
  public otherGroups = [];
  public showFooter = false;
  public workorderType= 0;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public modalCtrl: ModalController,
      public changeDetector: ChangeDetectorRef,
      public superTabsCtrl: SuperTabsController,
      public reportService: ReportService,
      public alertCtrl: AlertController,
      public translate: TranslateService,
      public apiService: ApiService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    this.workorderType = parseInt(this.data.workorder_type);
    if(!this.data.location) this.data.location = {};
    if(!this.data.location.units) this.data.location.units = [];
    for(let unit of this.data.location.units){
      if(!unit._unit_id) unit._unit_id = (unit.unit_id ? unit.unit_id : 'n' + new Date().getTime());
      if(!unit.unit_model_unit_type){
        // Tijdelijke fix i.v.m. overgang naar meerdere toesteltypen
        unit.unit_model_unit_type = 1;
      }
      // Set _selected_units als deze unit al via de search is geselecteerd
      if(unit._selected){
        this.data._selected_unit = unit; // Deprecated since 22-5-2020
        this.data._selected_units = [unit];
      }
    }
    this.units = this.data.location.units;
    this.sortUnits();
    // set allowAddUnit
    if(
      this.apiService.hasActiveSubscription('BASIS') ||
      this.apiService.hasActiveSubscription('UNIT_CV') ||
      this.apiService.hasActiveSubscription('UNIT_VENTILATIE') ||
      this.apiService.hasActiveSubscription('UNIT_WATERONTHARDER') ||
      this.apiService.hasActiveSubscription('UNIT_HIJSTOESTEL') ||
      this.apiService.hasActiveSubscription('UNIT_AIRCO') ||
      this.apiService.hasActiveSubscription('UNIT_GAS_OF_SFEERHAARD')
    ){
      this.allowAddUnit = true;
    } else {
      this.allowAddUnit = false;
    }
  }

  ionViewDidEnter() {
    console.log('ReportSelectUnitPage: ionViewDidEnter');
    this.initForm();
    // Check selected unit
    this.checkSelectedUnit();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportSelectUnitPage: ionViewDidLeave');
    if(this.data._selected_unit){
      this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportSelectUnitPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_error', 'mainTabs');
      this.data._valid.reportSelectUnitPage = -1;
    }
    this.save();
  }

  selectUnit(unit){
    for(let j = 0; j < this.units.length; j++){
      this.units[j]._selected = false;
    }
    unit._selected = true;
    this.data._selected_unit = unit; // Deprecated since 22-5-2020
    this.data._selected_units = [unit];
    this.data.checklist = null;
    this.checkSelectedUnit();
    if(this.data._show_all_tabs){
      this.superTabsCtrl.setColor('reportChecklistPage', 'tab_error', 'mainTabs');
      this.data._valid.reportChecklistPage = -1;
      this.data.reports = null;
      this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_error', 'mainTabs');
      this.data._valid.reportMeasurementPage = -1;
    }
    this.reportService.save();
  }

  chooseType(){
    let buttons = [];
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Algemeen'),
        handler: () => {
          this.addUnit(8);
        }
      });
      buttons.push({
        text: this.translate.instant('Airco'),
        handler: () => {
          this.addUnit(5);
        }
      });
    }
    buttons.push({
      text: this.translate.instant('CV'),
      handler: () => {
        this.addUnit(1);
      }
    });
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Gasleiding'),
        handler: () => {
          this.addUnit(7);
        }
      });
    }
    buttons.push({
      text: this.translate.instant('Gas- of sfeerhaard'),
      handler: () => {
        this.addUnit(9);
      }
    });
    if(this.workorderType != 7){
      buttons.push({
        text: this.translate.instant('Ventilatie'),
        handler: () => {
          this.addUnit(2);
        }
      });
      buttons.push({
        text: this.translate.instant('Waterontharder'),
        handler: () => {
          this.addUnit(3);
        }
      });
      buttons.push({
        text: this.translate.instant('Hijstoestel'),
        handler: () => {
          this.addUnit(4);
        }
      });
      buttons.push({
        text: this.translate.instant('CO2 melder'),
        handler: () => {
          this.addUnit(0);
        }
      });
      buttons.push({
        text: this.translate.instant('Warmtepomp'),
        handler: () => {
          this.addUnit(0);
        }
      });
      buttons.push({
        text: this.translate.instant('Warmtepomp boiler'),
        handler: () => {
          this.addUnit(0);
        }
      });
    }
    this.alertCtrl.create({
      title: this.translate.instant('Kies het type installatie'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  addUnit(unitType){
    if(
      (unitType === 1 && this.apiService.hasActiveSubscription('UNIT_CV')) ||
      (unitType === 2 && this.apiService.hasActiveSubscription('UNIT_VENTILATIE')) ||
      (unitType === 3 && this.apiService.hasActiveSubscription('UNIT_WATERONTHARDER')) ||
      (unitType === 4 && this.apiService.hasActiveSubscription('UNIT_HIJSTOESTEL')) ||
      (unitType === 5 && this.apiService.hasActiveSubscription('UNIT_AIRCO')) ||
      (unitType === 7 && this.apiService.hasActiveSubscription('UNIT_CV')) ||
      (unitType === 8 && this.apiService.hasActiveSubscription('BASIS')) ||
      (unitType === 9 && this.apiService.hasActiveSubscription('UNIT_GAS_OF_SFEERHAARD'))
    ){
      this.modalCtrl.create(ReportAddUnitPage, {
        unitType: unitType,
        parent: this
      }, {
        cssClass: 'modal-fullscreen'
      }).present();
    } else {
      this.alertCtrl.create({
        title: this.translate.instant('Geen licentie'),
        message: this.translate.instant('U mag dit type installatie niet toevoegen omdat u geen licentie heeft voor dit type installatie.'),
        buttons: [this.translate.instant('OK')]
      }).present();
    }
  }

  editUnit(unit){
    this.modalCtrl.create(ReportEditUnitPage, {
      unit: unit,
      parent: this
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  checkSelectedUnit(){
    if (!this.data._selected_units || this.data._selected_units.length <= 0) {
      return 0;
    }
    let selectedUnit = this.data._selected_units[0];
    // Check passport_nr
    const passportRegex = /^([A-Z]{2})([0-9]{2})M([0-9]){14}$/;
    let passportNrCheck = false;
    const passportNr = selectedUnit.passport_nr;
    const newPassportNr = selectedUnit.new_passport_nr;
    if(passportRegex.test(passportNr)){
      passportNrCheck = true;
    }
    if(passportRegex.test(newPassportNr)){
      passportNrCheck = true;
    }
    // Check nominal_power
    let nominalPowerCheck = true;
    const nominalPower = selectedUnit.nominal_power;
    const unitType = selectedUnit.unit_model_unit_type;
    if (unitType == 1 && this.workorderType != 7 && !nominalPower) {
      nominalPowerCheck = false;
    }
    // Create message
    let message = ''
    if(!passportNrCheck && !nominalPowerCheck){
      message = this.translate.instant('Er is geen geldig installatiepas nummer en nominaal vermogen ingevuld bij de geselecteerde installatie.');
    } else if(!passportNrCheck){
      message = this.translate.instant('Er is geen geldig installatiepas nummer ingevuld bij de geselecteerde installatie.');
    } else if(!nominalPowerCheck){
      message = this.translate.instant('Er is geen geldig nominaal vermogen ingevuld bij de geselecteerde installatie.');
    }
    // Show alert
    if(message){
      message += ' ' + this.translate.instant('Pas dit aan voordat u verder gaat.');
      this.alertCtrl.create({
        title: this.translate.instant('Geselecteerde installatie'),
        message: message,
        buttons: [this.translate.instant('OK')]
      }).present();
    }
  }

  isValid(){
    return (this.data._selected_units && this.data._selected_units.length > 0);
  }

  save(){
    this.data.location.units = this.units;
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportFilesPage', 'mainTabs');
    });
  }

  sortUnits(){
    this.otherGroups = [];
    if(this.units.length === 0){
      return;
    }
    // Sort by unit_model_unit_type
    this.units.sort((a, b) => {
      if (a.unit_model_unit_type > b.unit_model_unit_type) return 1;
      if (b.unit_model_unit_type > a.unit_model_unit_type) return -1;
      return 0;
    });
    // Set group fields
    let group = '';
    let prev_group;
    let types_found = [];
    for(let unit of this.units){
      prev_group = group;
      group = '';
      let unit_model_unit_type = parseInt(unit.unit_model_unit_type);
      types_found.push(unit_model_unit_type);
      switch(unit_model_unit_type){
        case 1:
          group = 'CV\'s';
          break;
        case 2:
          group = 'Ventilatie';
          break;
        case 3:
          group = 'Waterontharders';
          break;
        case 4:
          group = 'Hijstoestellen';
          break;
        case 5:
          group = 'Airco\'s';
          break;
        case 7:
          group = 'Gasleidingen';
          break;
        case 8:
          group = 'Algemeen';
          break;
        case 9:
          group = 'Gas- of sfeerhaarden';
          break;
        default:
          group = 'Anders';
      }
      unit._group = group;
      unit._group_same_as_prev = (group == prev_group);
    }
    // Set otherGroups
    if(types_found.indexOf(1) === -1){
      this.otherGroups.push('CV\'s');
    }
    if(types_found.indexOf(2) === -1){
      this.otherGroups.push('Ventilatie');
    }
    if(types_found.indexOf(3) === -1){
      this.otherGroups.push('Waterontharders');
    }
    if(types_found.indexOf(4) === -1){
      this.otherGroups.push('Hijstoestellen');
    }
    if(types_found.indexOf(5) === -1){
      this.otherGroups.push('Airco\'s');
    }
    if(types_found.indexOf(7) === -1){
      this.otherGroups.push('Gasleidingen');
    }
    if(types_found.indexOf(9) === -1){
      this.otherGroups.push('Gas- of sfeerhaarden');
    }
    this.otherGroups.push('CO2 melders, Warmtepompen, Warmtepomp boilers');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-select-unit/report-select-unit.ts